<template>
  <vs-popup
    :active.sync="active"
    :title="$t('company.theme_form')"
    class="hovers-popup"
  >
    <div class="theme-config-form">
      <form-wizard ref="wizard"
                   v-if="active"
                   color="#1976d2"
                   :title="$t('company.theme_form')"
                   :subtitle="''"
                   :hide-buttons="true"
                   :editable="true"
                   @on-change="onWizardChange"
      >
        <!-- Step 1: Global Config -->
        <tab-content :title="$te('company.theme.global') ? $t('company.theme.global') : 'Configuración Global'">
          <div class="tab-content">
              <vs-row>
                <vs-col vs-w="12">
                  <div class="delivery-form">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel1"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Información Domicilio"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel1"
                          v-model="themeConfig.global.label1"
                          :label-placeholder="'Información Domicilio'"
                          :danger="stepErrors[1] && !themeConfig.global.label1"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel2"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "¡Rastrea y hazle seguimiento a tu entrega!"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel2"
                          v-model="themeConfig.global.label2"
                          :label-placeholder="'¡Rastrea y hazle seguimiento a tu entrega!'"
                          :danger="stepErrors[1] && !themeConfig.global.label2"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel3"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Datos de la entrega"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel3"
                          v-model="themeConfig.global.label3"
                          :label-placeholder="'Datos de la entrega'"
                          :danger="stepErrors[1] && !themeConfig.global.label3"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel4"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Novedades"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel4"
                          v-model="themeConfig.global.label4"
                          :label-placeholder="'Novedades'"
                          :danger="stepErrors[1] && !themeConfig.global.label4"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel5"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Número de entrega"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel5"
                          v-model="themeConfig.global.label5"
                          :label-placeholder="'Número de entrega'"
                          :danger="stepErrors[1] && !themeConfig.global.label5"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel16"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Nombre del cliente"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel16"
                          v-model="themeConfig.global.label16"
                          :label-placeholder="'Nombre del cliente'"
                          :danger="stepErrors[1] && !themeConfig.global.label16"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel6"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Ciudad"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel6"
                          v-model="themeConfig.global.label6"
                          :label-placeholder="'Ciudad'"
                          :danger="stepErrors[1] && !themeConfig.global.label6"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel7"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Parte desde"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel7"
                          v-model="themeConfig.global.label7"
                          :label-placeholder="'Parte desde'"
                          :danger="stepErrors[1] && !themeConfig.global.label7"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel8"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Se entrega"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel8"
                          v-model="themeConfig.global.label8"
                          :label-placeholder="'Se entrega'"
                          :danger="stepErrors[1] && !themeConfig.global.label8"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel9"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Dirección de entrega"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel9"
                          v-model="themeConfig.global.label9"
                          :label-placeholder="'Dirección de entrega'"
                          :danger="stepErrors[1] && !themeConfig.global.label9"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel10"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Tiempo aproximado de entrega"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel10"
                          v-model="themeConfig.global.label10"
                          :label-placeholder="'Tiempo aproximado de entrega'"
                          :danger="stepErrors[1] && !themeConfig.global.label10"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel11"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Datos del conductor"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel11"
                          v-model="themeConfig.global.label11"
                          :label-placeholder="'Datos del conductor'"
                          :danger="stepErrors[1] && !themeConfig.global.label11"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel12"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Nombre del conductor"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel12"
                          v-model="themeConfig.global.label12"
                          :label-placeholder="'Nombre del conductor'"
                          :danger="stepErrors[1] && !themeConfig.global.label12"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel13"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Placa"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel13"
                          v-model="themeConfig.global.label13"
                          :label-placeholder="'Placa'"
                          :danger="stepErrors[1] && !themeConfig.global.label13"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.enableLabel14"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                          />
                          <span class="switch-text">Mostrar "Ver evidencias"</span>
                        </div>
                        <vs-input
                          v-if="themeConfig.global.enableLabel14"
                          v-model="themeConfig.global.label14"
                          :label-placeholder="'Ver evidencias'"
                          :danger="stepErrors[1] && !themeConfig.global.label14"
                          @input="validateOnInput"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <div class="switch-inline">
                          <vs-switch
                            v-model="themeConfig.global.label15"
                            color="primary"
                            :true-value="true"
                            :false-value="false"
                            @input="validateOnInput"
                          />
                          <span class="switch-text">Habilitar formulario de busqueda</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>

              
              </vs-row>
            </div>
        </tab-content>

        <!-- Step 2: Dark Theme -->
        <tab-content :title="$te('company.theme.dark') ? $t('company.theme.dark') : 'Tema Oscuro'">
          <div class="tab-content">
            <vs-row>
              <vs-col vs-w="12" class="mb-3">
                <div class="image-upload-container">
                  <input
                    type="file"
                    ref="darkLogoInput"
                    accept="image/*"
                    @change="handleDarkLogoChange"
                    class="hidden"
                  />
                  <vs-button
                    color="primary"
                    type="border"
                    @click="$refs.darkLogoInput.click()"
                  >
                    {{ $t('company.theme.logo_upload') }}
                  </vs-button>
                  <div v-if="themeConfig.dark.logo" class="image-preview">
                    <img :src="themeConfig.dark.logo" alt="Dark Logo Preview" />
                    <vs-button
                      type="border"
                      color="danger"
                      size="small"
                      @click="clearDarkLogo"
                      icon="close"
                    />
                  </div>
                </div>
              </vs-col>

              <!-- Dark: CEDI Icon -->
              <vs-col vs-w="12" class="mb-3">
                <div class="image-upload-container">
                  <input
                    type="file"
                    ref="darkCediInput"
                    accept="image/*"
                    @change="handleDarkCediChange"
                    class="hidden"
                  />
                  <vs-button color="primary" type="border" @click="$refs.darkCediInput.click()">
                    {{ $t('company.theme.cedi_logo_upload') }}
                  </vs-button>
                  <div v-if="themeConfig.dark.cediLogo" class="image-preview">
                    <img :src="themeConfig.dark.cediLogo" alt="Dark CEDI Icon Preview" />
                    <vs-button type="border" color="danger" size="small" @click="clearDarkCedi" icon="close" />
                  </div>
                </div>
              </vs-col>

              <!-- Dark: Resource Icon -->
              <vs-col vs-w="12" class="mb-3">
                <div class="image-upload-container">
                  <input
                    type="file"
                    ref="darkResourceInput"
                    accept="image/*"
                    @change="handleDarkResourceChange"
                    class="hidden"
                  />
                  <vs-button color="primary" type="border" @click="$refs.darkResourceInput.click()">
                    {{ $t('company.theme.resource_logo_upload') }}
                  </vs-button>
                  <div v-if="themeConfig.dark.resourceLogo" class="image-preview">
                    <img :src="themeConfig.dark.resourceLogo" alt="Dark Resource Icon Preview" />
                    <vs-button type="border" color="danger" size="small" @click="clearDarkResource" icon="close" />
                  </div>
                </div>
              </vs-col>

              <vs-col vs-w="12" class="mb-3">
                <div class="image-upload-container">
                  <input
                    type="file"
                    ref="darkMarkerInput"
                    accept="image/*"
                    @change="handleDarkMarkerChange"
                    class="hidden"
                  />
                  <vs-button
                    color="primary"
                    type="border"
                    @click="$refs.darkMarkerInput.click()"
                  >
                    {{ $t('company.theme.market_logo_upload') }}
                  </vs-button>
                  <div v-if="themeConfig.dark.markerLogo" class="image-preview">
                    <img :src="themeConfig.dark.markerLogo" alt="Market logo preview" />
                    <vs-button
                      type="border"
                      color="danger"
                      size="small"
                      @click="clearDarkMarker"
                      icon="close"
                    />
                  </div>
                </div>
              </vs-col>

              <vs-col vs-w="12" class="mb-3">
                <label class="vs-input--label">{{ $t('company.theme.background_menu') }}</label>
                <div class="color-picker">
                  <input
                    type="color"
                    v-model="themeConfig.dark.menuColor"
                    class="native-color-input"
                    @input="validateOnInput"
                  />
                </div>
              </vs-col>
            </vs-row>
          </div>
        </tab-content>

        <!-- Step 3: Light Theme -->
        <tab-content :title="$te('company.theme.light') ? $t('company.theme.light') : 'Tema Claro'">
          <div class="tab-content">
              <vs-row>
                <vs-col vs-w="12" class="mb-3">
                  <div class="image-upload-container">
                    <input
                      type="file"
                      ref="lightLogoInput"
                      accept="image/*"
                      @change="handleLightLogoChange"
                      class="hidden"
                    />
                    <vs-button
                      color="primary"
                      type="border"
                      @click="$refs.lightLogoInput.click()"
                    >
                      {{ $t('company.theme.logo_upload') }}
                    </vs-button>
                    <div v-if="themeConfig.light.logo" class="image-preview">
                      <img :src="themeConfig.light.logo" alt="Light Logo Preview" />
                      <vs-button
                        color="danger"
                        size="small"
                        @click="clearLightLogo"
                        icon="close"
                      />
                    </div>
                  </div>
                </vs-col>

                <!-- Light: CEDI Icon -->
                <vs-col vs-w="12" class="mb-3">
                  <div class="image-upload-container">
                    <input
                      type="file"
                      ref="lightCediInput"
                      accept="image/*"
                      @change="handleLightCediChange"
                      class="hidden"
                    />
                    <vs-button color="primary" type="border" @click="$refs.lightCediInput.click()">
                      {{ $t('company.theme.cedi_logo_upload') }}
                    </vs-button>
                    <div v-if="themeConfig.light.cediLogo" class="image-preview">
                      <img :src="themeConfig.light.cediLogo" alt="Light CEDI Icon Preview" />
                      <vs-button type="border" color="danger" size="small" @click="clearLightCedi" icon="close" />
                    </div>
                  </div>
                </vs-col>

                <!-- Light: Resource Icon -->
                <vs-col vs-w="12" class="mb-3">
                  <div class="image-upload-container">
                    <input
                      type="file"
                      ref="lightResourceInput"
                      accept="image/*"
                      @change="handleLightResourceChange"
                      class="hidden"
                    />
                    <vs-button color="primary" type="border" @click="$refs.lightResourceInput.click()">
                      {{ $t('company.theme.resource_logo_upload') }}
                    </vs-button>
                    <div v-if="themeConfig.light.resourceLogo" class="image-preview">
                      <img :src="themeConfig.light.resourceLogo" alt="Light Resource Icon Preview" />
                      <vs-button type="border" color="danger" size="small" @click="clearLightResource" icon="close" />
                    </div>
                  </div>
                </vs-col>

                <vs-col vs-w="12" class="mb-3">
                  <div class="image-upload-container">
                    <input
                      type="file"
                      ref="lightMarkerInput"
                      accept="image/*"
                      @change="handleLightMarkerChange"
                      class="hidden"
                    />
                    <vs-button
                      color="primary"
                      type="border"
                      @click="$refs.lightMarkerInput.click()"
                    >
                      {{ $t('company.theme.market_logo_upload') }}
                    </vs-button>
                    <div v-if="themeConfig.light.markerLogo" class="image-preview">
                      <img :src="themeConfig.light.markerLogo" alt="Market logo preview" />
                      <vs-button
                        type="border"
                        color="danger"
                        size="small"
                        @click="clearLightMarker"
                        icon="close"
                      />
                    </div>
                  </div>
                </vs-col>

                <vs-col vs-w="12" class="mb-3">
                  <label class="vs-input--label">{{ $t('company.theme.background_menu') }}</label>
                  <div class="color-picker">
                    <input
                      type="color"
                      v-model="themeConfig.light.menuColor"
                      class="native-color-input"
                      @input="validateOnInput"
                    />
                  </div>
                </vs-col>
              </vs-row>
            </div>
        </tab-content>

      </form-wizard>

      <div class="actions-footer">
        <div class="step-navigation">
          <vs-tooltip v-if="showTooltips && step > 1" position="top" color="primary">
            <template #tooltip>
              {{ $t('company.theme_navigation.previous_step') }}
            </template>
            <vs-button
              color="primary"
              type="border"
              @click="previousStep"
            >
              {{ $t('previous') }}
            </vs-button>
          </vs-tooltip>

          <vs-tooltip v-if="showTooltips && step < 3" position="top" color="primary">
            <template #tooltip>
              {{ stepErrors[step] ? $t('company.theme_navigation.complete_fields') : $t('company.theme_navigation.next_step') }}
            </template>
            <vs-button
              color="primary"
              :disabled="stepErrors[step]"
              @click="nextStep"
            >
              {{ $t('next') }}
            </vs-button>
          </vs-tooltip>

          <vs-tooltip v-else-if="showTooltips" position="top" color="success">
            <template #tooltip>
              {{ stepErrors[step] ? $t('company.theme_navigation.complete_fields') : $t('company.theme_navigation.save_step') }}
            </template>
            <vs-button
              color="success"
              :disabled="stepErrors[step] || isSaving"
              :loading="isSaving"
              @click="saveThemeConfig"
            >
              {{ $t('save') }}
            </vs-button>
          </vs-tooltip>

          <div v-if="stepErrors[step]" class="validation-message">
            {{ $t('company.theme_navigation.complete_fields') }}
          </div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import HTTP from "@/http-common";
import ErrorNotify from "@/components/errors/Errors";
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  name: 'ThemeConfigModal',
  components: { FormWizard, TabContent },
  
  data() {
    return {
      active: false,
      step: 1,
      isSaving: false,
      showTooltips: true,
      company_id: null,
      stepErrors: {
        1: false,
        2: false,
        3: false
      },
      themeConfig: {
        global: {
          label1: '',
          label2: '',
          label3: '',
          label4: '',
          label5: '',
          label6: '',
          label7: '',
          label8: '',
          label9: '',
          label10: '',
          label11: '',
          label12: '',
          label13: '',
          label14: '',
          label15: true,
          label16: '',
          enableLabel1: true,
          enableLabel2: true,
          enableLabel3: true,
          enableLabel4: true,
          enableLabel5: true,
          enableLabel6: true,
          enableLabel7: true,
          enableLabel8: true,
          enableLabel9: true,
          enableLabel10: true,
          enableLabel11: true,
          enableLabel12: true,
          enableLabel13: true,
          enableLabel14: true,
          enableLabel16: false
        },
        dark: {
          menuColor: '#2c2c2c',
          logo: null,
          markerLogo: null,
          cediLogo: null,
          resourceLogo: null
        },
        light: {
          menuColor: '#f8f8f8',
          logo: null,
          markerLogo: null,
          cediLogo: null,
          resourceLogo: null
        }
      }
    }
  },
  
  methods: {
    open(company) {
      this.company_id = company.id
      this.active = true
      this.step = 1
      this.showTooltips = true
      const defaults = this.getDefaultThemeConfig()
      if (company && company.config_theme) {
        const cfg = company.config_theme || {}
        this.themeConfig = {
          ...defaults,
          ...cfg,
          global: {
            ...defaults.global,
            ...(cfg.global || {})
          },
          dark: {
            ...defaults.dark,
            ...(cfg.dark || {})
          },
          light: {
            ...defaults.light,
            ...(cfg.light || {})
          }
        }
      } else {
        this.themeConfig = { ...defaults }
      }
    },

    getDefaultThemeConfig() {
      return {
        global: {
          label1: '',
          label2: '',
          label3: '',
          label4: '',
          label5: '',
          label6: '',
          label7: '',
          label8: '',
          label9: '',
          label10: '',
          label11: '',
          label12: '',
          label13: '',
          label14: '',
          label15: true,
          enableLabel1: true,
          enableLabel2: true,
          enableLabel3: true,
          enableLabel4: true,
          enableLabel5: true,
          enableLabel6: true,
          enableLabel7: true,
          enableLabel8: true,
          enableLabel9: true,
          enableLabel10: true,
          enableLabel11: true,
          enableLabel12: true,
          enableLabel13: true,
          enableLabel14: true
        },
        dark: {
          menuColor: '#2c2c2c',
          logo: null,
          markerLogo: null,
          cediLogo: null,
          resourceLogo: null
        },
        light: {
          menuColor: '#f8f8f8',
          logo: null,
          markerLogo: null,
          cediLogo: null,
          resourceLogo: null
        }
      }
    },

    onWizardChange(...args) {
      // Supports signatures: (newIndex) or (prevIndex, nextIndex)
      let idx = null
      if (args.length === 1) idx = args[0]
      else if (args.length >= 2) idx = args[1]
      if (typeof idx !== 'number') {
        // Fallback to 0 to avoid NaN
        idx = 0
      }
      this.step = Number(idx) + 1
    },
    handleDarkLogoChange(e) {
      const file = e.target.files[0]
      if (file) {
        if (file.size > 2000000) {
          this.$vs.notify({
            title: 'Error',
            text: 'La imagen no debe superar 2MB',
            color: 'danger'
          })
          this.$refs.darkLogoInput.value = ''
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.themeConfig.dark.logo = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    handleDarkMarkerChange(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 2000000) {
          this.$vs.notify({
            title: 'Error',
            text: 'La imagen no debe superar 2MB',
            color: 'danger'
          })
          this.$refs.darkMarkerInput.value = ''
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.themeConfig.dark.markerLogo = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    handleLightLogoChange(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 2000000) {
          this.$vs.notify({
            title: 'Error',
            text: 'La imagen no debe superar 2MB',
            color: 'danger'
          })
          this.$refs.lightLogoInput.value = ''
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.themeConfig.light.logo = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    handleLightMarkerChange(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 2000000) {
          this.$vs.notify({
            title: 'Error',
            text: 'La imagen no debe superar 2MB',
            color: 'danger'
          })
          this.$refs.lightMarkerInput.value = ''
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.themeConfig.light.markerLogo = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    handleDarkCediChange(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 2000000) {
          this.$vs.notify({
            title: 'Error',
            text: 'La imagen no debe superar 2MB',
            color: 'danger'
          })
          this.$refs.darkCediInput && (this.$refs.darkCediInput.value = '')
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.themeConfig.dark.cediLogo = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    handleDarkResourceChange(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 2000000) {
          this.$vs.notify({
            title: 'Error',
            text: 'La imagen no debe superar 2MB',
            color: 'danger'
          })
          this.$refs.darkResourceInput && (this.$refs.darkResourceInput.value = '')
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.themeConfig.dark.resourceLogo = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    handleLightCediChange(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 2000000) {
          this.$vs.notify({
            title: 'Error',
            text: 'La imagen no debe superar 2MB',
            color: 'danger'
          })
          this.$refs.lightCediInput && (this.$refs.lightCediInput.value = '')
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.themeConfig.light.cediLogo = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    handleLightResourceChange(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 2000000) {
          this.$vs.notify({
            title: 'Error',
            text: 'La imagen no debe superar 2MB',
            color: 'danger'
          })
          this.$refs.lightResourceInput && (this.$refs.lightResourceInput.value = '')
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          this.themeConfig.light.resourceLogo = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    clearDarkLogo() {
      this.themeConfig.dark.logo = null
      this.$refs.darkLogoInput.value = ''
    },
    clearDarkMarker() {
      this.themeConfig.dark.markerLogo = null
      this.$refs.darkMarkerInput.value = ''
    },
    clearLightLogo() {
      this.themeConfig.light.logo = null
      this.$refs.lightLogoInput.value = ''
    },
    clearDarkCedi() {
      this.themeConfig.dark.cediLogo = null
      this.$refs.darkCediInput && (this.$refs.darkCediInput.value = '')
    },
    clearDarkResource() {
      this.themeConfig.dark.resourceLogo = null
      this.$refs.darkResourceInput && (this.$refs.darkResourceInput.value = '')
    },
    clearLightCedi() {
      this.themeConfig.light.cediLogo = null
      this.$refs.lightCediInput && (this.$refs.lightCediInput.value = '')
    },
    clearLightResource() {
      this.themeConfig.light.resourceLogo = null
      this.$refs.lightResourceInput && (this.$refs.lightResourceInput.value = '')
    },
    clearLightMarker() {
      this.themeConfig.light.markerLogo = null
      this.$refs.lightMarkerInput.value = ''
    },
    validateStep() {
      // All fields optional: always valid
      this.stepErrors[this.step] = false
      return true
    },

    validateOnInput() {},

    previousStep() {
      const wiz = this.$refs.wizard
      if (wiz) {
        if (typeof wiz.prevTab === 'function') {
          wiz.prevTab()
        } else if (typeof wiz.previousTab === 'function') {
          wiz.previousTab()
        } else if (typeof wiz.changeTab === 'function') {
          // wizard is 0-based, go to (current step - 2)
          wiz.changeTab(Math.max(0, Number(this.step) - 2))
        }
      } else if (this.step > 1) {
        this.step--
      }
    },

    nextStep() {
      if (this.$refs.wizard) {
        this.$refs.wizard.nextTab()
      } else if (this.step < 3) {
        this.step++
      }
      const currentStep = this.step
      this.stepErrors[currentStep] = false
    },

    async saveThemeConfig() {
      this.isSaving = true
      try {
        const url = `v1/companies/updateTheme/${this.company_id}`
        HTTP.setHeader(true)
        await HTTP.put(url, this.themeConfig)
        this.$vs.notify({
          text: this.$t("company.update"),
          color: "#64cc52",
          iconPack: "feather",
          icon: "icon-check-circle",
        })
        // Hide tooltips to avoid DOM ops during teardown
        this.showTooltips = false
        // Close the popup first
        this.active = false
        // After closing cycle, ask parent to refresh
        this.$nextTick(() => {
          setTimeout(() => this.$emit("refreshTable"), 30)
        })
      } catch (response) {
        // If axios-like error, keep same structure used previously
        ErrorNotify.formsErrors({
          data: response?.response,
          ob: this,
        })
        this.$vs.notify({
          title: 'Error',
          text: response?.message || this.$t('error') || 'Error',
          color: 'danger'
        })
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>

<style scoped>
.theme-config-form {
  padding: 1rem;
}
.actions-footer {
  margin-top: 1.5rem;
  text-align: right;
}

/* Color picker layout */
.color-picker {
  display: flex;
  /* align-items: center; */
  /* justify-content: center; */
  position: relative;
  gap: 0.8rem;
}

.native-color-input {
  width: 100px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
}

.delivery-form .form-row {
  display: flex;
  margin: 0 -0.5rem;
  margin-bottom: 1rem;
}

.delivery-form .form-group {
  padding: 0 0.5rem;
  margin-bottom: 0;
  flex: 1;
}

.image-upload-container {
  margin-top: 0.5rem;

  .image-preview {
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    img {
      max-width: 100px;
      height: auto;
    }
  }
}


.step-navigation {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 1rem;

  .validation-message {
    color: var(--vs-danger);
    font-size: 0.875rem;
    margin-left: 1rem;
  }
}

.delivery-form .form-row .form-group {
  padding: 0 0.5rem;
  flex: unset;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
}

.delivery-form .form-row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Switch label alignment */
.switch-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.switch-text {
  line-height: 1.2;
  user-select: none;
}
</style>
